import {Middleware} from 'redux';

import {MiddlewareAction} from './middleware-action';

/** Handles shell window-opening actions emitted by the app store. */
// eslint-disable-next-line unicorn/consistent-function-scoping
export const windowMiddleware: Middleware = () => next => (action: MiddlewareAction) => {
    switch (action.type) {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        case 'middleware/OPEN_WINDOW': {
            const {url, name, features} = action.payload;
            window.open(url, name, features);
            break;
        }
        default: {
            return next(action);
        }
    }

    return next(action);
};
